import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Logo from "../../../images/header/logo.png";
import axios from 'axios';


const Sidebar = ({logoImg, clientDetails, handleToast}) => {
      if (!logoImg) {
        logoImg = Logo;
      }

      const [isActive, setIsActive] = useState(true);
    console.log(clientDetails);
        const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
 
        const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

      const staffAs = localStorage.getItem("staff_as");
  const staffDetails = staffAs ? JSON.parse(staffAs) : null;

  const permissions = staffDetails?.permissions
    ? JSON.parse(staffDetails.permissions)
    : {};


    // const handleLogout = () => {
    //     localStorage.removeItem('userData');
    //     if(isAdmin) {
    //     localStorage.removeItem('isAdmin', 'true');
    //     navigate('/admin-login');
    //     }
    //     if(isStaff) {
    //     localStorage.removeItem('isStaff', 'true');
    //     navigate('/staff-login');
    //     }
    //     window.location.reload();
    // }

const safeNavigate = async (path) => {
  if (!clientDetails.id) {
    handleToast({
      toastMsg: "Client ID missing. Contact support.",
      toastColor: "#FF0000",
    });
    return;
  }

  try {
    const response = await axios.get(`https://api.dectwinhotel.com/api/check-active/${clientDetails.id}`);
    
    if (response.data.is_active == "Yes") {
      setIsActive(true);
      navigate(path);
    } else {
      setIsActive(false);
      handleToast({
        toastMsg: "ID Inactive. Contact Support!",
        toastColor: "#FF0000",
      });
    }
  } catch (error) {
    console.error("Error fetching active status:", error);
    handleToast({
      toastMsg: "Error checking ID status.",
      toastColor: "#FF0000",
    });
  }
};


  return (
    <>
                  <div className={`sidebar-area ${collapsed ? "" : "collapsed"}`}>

                {/* <span className="w-auto sidebar-item py-2 px-2" onClick={toggleSidebar}>
                    <i className={`fa-solid ${collapsed ? "fa-angle-left" : "fa-angle-right"}`}></i>
                </span> */}

                <div className='d-flex'>
                    <div className='align-content-center text-light'>
                    <img src={logoImg} className='sidebar-logo me-2' alt='Logo Sidebar' />
                                    {/* <div className='creator'>
                    {clientDetails.hotel_id === undefined ? "" : <p><ins>Client ID </ins>  {clientDetails.hotel_id}</p>}
                </div> */}

                    </div>
                    <div className='align-content-center text-light sidebar-text'>
<p className='fw-bold fs-5 my-0'>{clientDetails.business_name}</p>
<p className='fw-normal my-0'>{clientDetails.name === undefined ? "Name" : clientDetails.name}</p>
                {/* <p>{clientDetails.address === undefined ? "Address" : clientDetails.address}</p> */}
                                    </div>
                </div>

{staffDetails === null && (
                    <div className='mt-4'>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/'); setCollapsed(false) }}><i class="fa-regular fa-chart-bar"></i><Link className='sidebar-text'>Dashboard</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/rooms'); setCollapsed(false) }}><i class="fa-solid fa-bed"></i><Link className='sidebar-text'>Rooms</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/foods'); setCollapsed(false) }}><i class="fa-solid fa-utensils"></i><Link className='sidebar-text'>Foods</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/staff'); setCollapsed(false) }}><i class="fa-solid fa-people-group"></i><Link className='sidebar-text'>Staff</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/purchase-bill'); setCollapsed(false) }}><i class="fa-solid fa-sheet-plastic"></i><Link className='sidebar-text'>Purchase Bill</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/daily-track'); setCollapsed(false) }}><i class="fa-solid fa-chart-column"></i><Link className='sidebar-text'>Daily Track</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/reports'); setCollapsed(false) }}><i class="fa-solid fa-hotel"></i><Link className='sidebar-text'>Reports</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/settlement-report'); setCollapsed(false) }}><i class="fa-regular fa-bookmark"></i><Link className='sidebar-text'>Settlement</Link></p>
                        <p className='sidebar-item' onClick={() => { safeNavigate('/admin/due-history'); setCollapsed(false) }}><i class="fa-solid fa-money-bill"></i><Link className='sidebar-text'>Due History</Link></p>
                        {/* <p className='sidebar-item' onClick={() => { navigate('/admin/logout') }}><i class="fa-solid fa-power-off"></i><Link className='sidebar-text'>Log Out</Link></p> */}
</div>
)}

{staffDetails !== null && (
  <div className='mt-4'>
    <p className='sidebar-item' onClick={() => { navigate('/'); setCollapsed(false) }}>
      <i className="fa-regular fa-chart-bar"></i><Link className='sidebar-text'>Dashboard</Link>
    </p>

    {permissions.room &&
      <p className='sidebar-item' onClick={() => { navigate('/admin/rooms'); setCollapsed(false) }}>
        <i className="fa-regular fa-bookmark"></i><Link className='sidebar-text'>Rooms</Link>
      </p>
    }

    {permissions.food &&
      <p className='sidebar-item' onClick={() => { navigate('/admin/foods'); setCollapsed(false) }}>
        <i className="fa-solid fa-money-bill"></i><Link className='sidebar-text'>Foods</Link>
      </p>
    }

    {permissions.food &&
      <p className='sidebar-item' onClick={() => { navigate('/admin/reports'); setCollapsed(false) }}>
        <i className="fa-solid fa-eye"></i><Link className='sidebar-text'>Reports</Link>
      </p>
    }

  </div>
)}

                            <p className='sidebar-item' onClick={() => { navigate('/admin/logout') }}><i class="fa-solid fa-power-off"></i><Link className='sidebar-text'>Log Out</Link></p>
<br />
                <span className="sidebar-btn py-2" onClick={toggleSidebar}>
                    <i className={`fa-solid ${collapsed ? "fa-angle-left" : "fa-angle-right"}`}></i>
                </span>
                </div>


    </>
  )
}

export default Sidebar
